<script>
  import { createEventDispatcher, getContext, onMount } from "svelte";
  import Button from "./Button.svelte";
  import compactIcon from "../assets/icons/compact.svg";
  import UserLink from "./UserLink.svelte";
  import BreadcrumbSlash from "./BreadcrumbSlash.svelte";
  import LinkButton from "./LinkButton.svelte";
  import { LINK_GALLERY } from "../util/constants";
  const dispatch = createEventDispatcher();

  const gallery = getContext("gallery");
  const compactStore = gallery.compact;
  const modeStore = gallery.mode;
  const tokenStore = gallery.token;
  const addressStore = gallery.address;
  const rangeStore = gallery.range;
  let isShort;

  let token, address, mode, range;
  const unsubMode = modeStore.subscribe((v) => {
    mode = v;
  });
  const unsubToken = tokenStore.subscribe((v) => {
    token = v;
  });
  const unsubAddress = addressStore.subscribe((v) => {
    address = v;
  });
  const unsubRange = rangeStore.subscribe((v) => {
    range = v;
  });
  handleResize();

  onMount(() => {
    return () => {
      unsubMode();
      unsubToken();
      unsubAddress();
      unsubRange();
    };
  });

  function handleResize() {
    isShort = window.innerWidth < 600;
  }
</script>

<svelte:window on:resize|passive={handleResize} />

<div class="container">
  <div class="breadcrumb">
    {#if mode === "address"}
      <LinkButton to={`/${LINK_GALLERY}`}>..</LinkButton>
      <BreadcrumbSlash />
      <UserLink
        link={false}
        addressAsPlaceholder
        short={isShort}
        address={$addressStore}
      />
    {:else if mode === "token"}
      {#if address}<LinkButton to={`/${LINK_GALLERY}`}>..</LinkButton>
        <BreadcrumbSlash />
        <UserLink short={isShort} {address} />
        <BreadcrumbSlash /> #{token}{/if}
    {:else}
      <BreadcrumbSlash />
    {/if}
  </div>
  {#if range && mode == "gallery"}
    <div class="range noselect">
      {`#${range[0]} – #${range[1]}`}
    </div>
  {/if}
  {#if !token}
    <div class="compact-button-container noselect">
      <Button
        icon={compactIcon}
        radio
        galleryToolbar
        toggled={$compactStore}
        on:click={(ev) => {
          gallery.compact.update(() => ev.detail.toggled);
        }}
      />
    </div>
  {/if}
</div>

<style>
  .container {
    width: 100%;
    overflow: hidden;
    --gallery-toolbar-height: 40px;
    /* background: pink; */
    height: var(--gallery-toolbar-height);
    border-bottom: 1px dashed black;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 10px;
    padding-right: 0;
  }

  .compact-button-container {
    border-left: 1px solid black;
    /* border-bottom: 1px solid black; */
    /* border-top: 1px solid black; */
    /* display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 10px; */
  }

  .breadcrumb {
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    gap: 10px;
  }

  .range {
    font-size: 11px;
  }
  @media screen and (max-width: 720px) {
    .container {
      padding-right: 20px;
    }
    .compact-button-container {
      display: none;
    }
  }
</style>
